import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { useIsMobile } from '../hooks/useIsMobile';
import { WeekData } from '../data/mockData';
interface WeeklyCommandSummaryProps {
  onReadMore: () => void;
  commandSummaryCopy: WeekData['commandSummaryCopy'];
}
export function WeeklyCommandSummary({
  onReadMore,
  commandSummaryCopy: c
}: WeeklyCommandSummaryProps) {
  const isMobile = useIsMobile();
  return <section style={{
    marginBottom: isMobile ? '20px' : '24px',
    paddingTop: isMobile ? '24px' : '40px',
    paddingBottom: isMobile ? '4px' : '6px'
  }} data-id="element-75">
      {/* Headline — briefing statement */}
      <h1 style={{
      fontSize: isMobile ? '20px' : '24px',
      fontWeight: 700,
      color: '#e8edf4',
      lineHeight: '1.25',
      margin: '0 0 6px 0',
      letterSpacing: '-0.01em'
    }} data-id="element-76">
        {c.headline}
      </h1>

      {/* Context line */}
      <p style={{
      fontSize: '12px',
      color: '#4e5f74',
      margin: '0 0 14px 0',
      lineHeight: '1.4'
    }} data-id="element-77">
        {c.contextLine}
      </p>

      {/* Command Summary card */}
      <button onClick={onReadMore} style={{
      display: 'block',
      width: '100%',
      background: '#111827',
      border: '1px solid rgba(255,255,255,0.07)',
      borderRadius: '10px',
      padding: isMobile ? '14px 16px' : '16px 20px',
      cursor: 'pointer',
      textAlign: 'left'
    }} data-id="element-78">
        <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '12px'
      }} data-id="element-79">
          <span style={{
          fontSize: '10px',
          fontWeight: 700,
          color: '#4e5f74',
          letterSpacing: '0.14em',
          textTransform: 'uppercase'
        }} data-id="element-80">
            {c.cardLabel}
          </span>
          <ChevronRightIcon size={14} color="#4e5f74" data-id="element-81" />
        </div>

        <ul style={{
        margin: 0,
        padding: 0,
        listStyle: 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }} data-id="element-82">
          {c.bullets.map((bullet, i) => <li key={i} style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'flex-start'
        }} data-id="element-83">
              <span style={{
            width: '3px',
            height: '3px',
            borderRadius: '50%',
            background: '#3b82f6',
            flexShrink: 0,
            marginTop: '8px'
          }} data-id="element-84" />
              <span style={{
            fontSize: '13px',
            fontWeight: 500,
            color: '#8b9ab0',
            lineHeight: '1.55'
          }} data-id="element-85">
                {bullet}
              </span>
            </li>)}
        </ul>
      </button>
    </section>;
}